import { render, staticRenderFns } from "./r-invoice.vue?vue&type=template&id=6920ab3c&"
import script from "./r-invoice.vue?vue&type=script&lang=js&"
export * from "./r-invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports